import { render, staticRenderFns } from "./textareaForm.vue?vue&type=template&id=14196cf2&scoped=true&"
import script from "./textareaForm.vue?vue&type=script&lang=js&"
export * from "./textareaForm.vue?vue&type=script&lang=js&"
import style0 from "./textareaForm.vue?vue&type=style&index=0&id=14196cf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14196cf2",
  null
  
)

export default component.exports